import axiosInstance from "../../axiosInstance/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { PercentageCompleteChangedAlertResponse } from "./PercentageCompleteChangedAlertResponse";
import { PercentageCompleteChangedAlertMapper } from "./PercentageCompleteChangedAlertMapper";

export const loadPercentageCompleteChangedAlertsByMilestoneIdAsync =
  createAsyncThunk(
    "percentageCompleteChangedAlerts/getByMilestoneId",
    async (milestoneId: number) => {
      const response = await axiosInstance.get<
        PercentageCompleteChangedAlertResponse[]
      >(`/PercentageCompleteChangedAlerts/${milestoneId}`);
      var percentageCompleteChangedAlertMapper =
        new PercentageCompleteChangedAlertMapper();
      return response.data.map((response) =>
        percentageCompleteChangedAlertMapper.mapToPercentageCompleteChangedAlert(
          response
        )
      );
    }
  );
